export default "__VITE_ASSET__C3o9EI_y__"